import type { ChatOrderProduct } from './ChatOrderProductCandidatesModal';

interface OptionListProps {
  product: ChatOrderProduct;
  selectedProductId: string | null;
  selectedOptionId: string | null;
  formatPrice: (amount: number) => string;
  onOptionSelect: (product: ChatOrderProduct, optionId: string) => void;
}

const OptionList = ({
  product,
  selectedProductId,
  selectedOptionId,
  formatPrice,
  onOptionSelect,
}: OptionListProps) => {
  const isProductSelected = selectedProductId === product._id;

  return (
    <div className="product-body">
      <div className="option-list">
        {product.options.map((option) => {
          const isOptionSelected = isProductSelected && selectedOptionId === option._id;
          return (
            <div
              key={option._id}
              className={`option-card ${isOptionSelected ? 'selected' : ''} ${!option.price ? 'disabled' : ''}`}
              role="radio"
              aria-checked={isOptionSelected}
              tabIndex={option.price ? 0 : -1}
              onClick={option.price ? () => onOptionSelect(product, option._id) : undefined}
              onKeyDown={option.price ? (e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); onOptionSelect(product, option._id); } } : undefined}
            >
              <div className={`option-radio ${isOptionSelected ? 'selected' : ''}`} />
              <div className="option-info">
                <div className="option-name">{option.name}</div>
                {option.price ? (
                  <div className="option-price">
                    {formatPrice(option.price.amount)}
                  </div>
                ) : (
                  <div className="option-price no-price">
                    가격 없음
                  </div>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default OptionList;
